const DropDownItemWrapper = ({ active, children }) => {
  return (
    <div
      className={`flex-1 overflow-y-auto space-y-0.5 p-2 ${active ? "block" : "hidden md:block"}`}
    >
      {children}
    </div>
  )
}

export default DropDownItemWrapper
